/**
 * Runtime selector that picks the right `DatabaseFactory` for the current
 * platform:
 *   - Tauri (desktop + Tauri Mobile spike) → `@powersync/tauri-plugin`
 *   - Plain web (incl. Tauri's debug WebView when the plugin isn't loaded)
 *     → `@powersync/web` (WASM + OPFS)
 *
 * Each platform-specific factory is loaded via dynamic import so the web
 * build never pulls Tauri SDKs into its critical chunk.
 */

import { type DatabaseFactory, webDatabaseFactory } from "@space/shared";
import { isTauriRuntime } from "@/lib/platform";

export async function selectDatabaseFactory(): Promise<DatabaseFactory> {
  if (isTauriRuntime()) {
    const { tauriDatabaseFactory } = await import("./tauri-factory");
    return tauriDatabaseFactory;
  }
  return webDatabaseFactory;
}
